import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { Tooltip } from '@intelie/ui'

import i18n from 'live/services/i18n'
import router from 'live/services/router'

import { crewOperationsStatusOptionsRegistry } from 'plugin-fracking/shared/lib/crew-operationstatus-options-registry'
import { canAccessPSR } from '../permissions/permissions'

const registerOperationStatusButton = (fracEventAlias: string, postStageReportAlias: string) => {
    if (canAccessPSR()) {
        crewOperationsStatusOptionsRegistry.register({
            title: i18n('Post Stage Report'),
            type: 'stage',
            // eslint-disable-next-line @typescript-eslint/no-unused-vars, react/display-name
            Component: props => {
                const isFinished = props.stage.end
                const isStage = props.stage.__src === 'crew-stage'
                const canAccessButton = isFinished && isStage

                const style = useMemo(() => {
                    return !canAccessButton
                        ? { color: 'var(--gray-600)', cursor: 'not-allowed', textDecoration: 'none' }
                        : {}
                }, [props, canAccessButton])

                const getButton = useCallback((): React.ReactElement => {
                    return (
                        <LinkLikeButton
                            onClick={event => {
                                if (!canAccessButton) return event.stopPropagation()

                                router.setHash(
                                    `/${fracEventAlias}/${postStageReportAlias}/${props.stage.assetId}/run/${props.stage.uid}`
                                )
                            }}
                            style={style}
                        >
                            <i style={style} className="far fa-file-alt" />
                            <span style={style}>{i18n('Post Stage Report')}</span>
                        </LinkLikeButton>
                    )
                }, [props, style, canAccessButton])

                return isStage ? (
                    <>
                        <div style={style}>
                            {!isFinished ? (
                                <Tooltip
                                    overlay={
                                        <>
                                            You cannot access the Post Stage Report page <br />
                                            while the stage is in progress. When <br />
                                            the stage is complete, you will be <br />
                                            able to access this page.
                                        </>
                                    }
                                    placement="bottom"
                                    textAlign="left"
                                >
                                    {getButton()}
                                </Tooltip>
                            ) : (
                                getButton()
                            )}
                        </div>
                    </>
                ) : null
            }
        })
    }
}

export default registerOperationStatusButton

const LinkLikeButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    color: var(--blue-500);
    text-decoration: none;
    cursor: pointer;

    :hover {
        text-decoration: underline;
    }
`
